module.exports = __webpack_public_path__ + "img/2012-08-18 13.12.50.964b0619.jpg";